// Authored display-helper copy missing from the existing Sales catalogs.
export const finalEmployeeArabicTranslations: Record<string, string> = {
  "Open WhatsApp flow": "فتح خطوات واتساب",
  "Open email flow": "فتح خطوات الإيميل",
  "Review payment": "مراجعة الدفع",
  "Open and update": "فتح وتحديث",
  "Call hot lead": "اتصل بالعميل المهتم جدًا",
  "Open workspace": "فتح مساحة الشغل",
  "No timestamp recorded": "مفيش تاريخ أو وقت متسجل",
  "Email not provided": "الإيميل مش موجود",
  "Lead detail": "تفاصيل العميل",
  "No check yet": "لسه متراجعش",
  "Unknown date": "التاريخ مش معروف",
  "No enrollments yet": "لسه مفيش التحاقات",
  "{0}m": "{0} دقيقة",
  "{0}h": "{0} ساعة",
  "{0}d": "{0} يوم",
  "No contact sample": "مفيش عينة بيانات تواصل",
  "No row sample": "مفيش عينة بيانات للصف",
  "Stored #{0}": "محفوظ #{0}",
  "Skipped": "اتخطى",
};

export const finalEmployeeEnglishTranslations: Record<string, string> = {};
